import { Apis } from 'Redux/APIs'
import axiosClient from 'Utils/axiosClient'

export const getMipsData = async (payload) => {

  const { provider, year } = payload
  const response = await axiosClient.get(`${Apis.MIPSGet}/${provider}/${year}`)
  return response.data
}

export const getMeasureInfo= async (payload) =>{
  const response = await axiosClient.get(Apis.MIPSSearch)
  return response.data
}

export const getMeasureVisitDetails =async (payload)=>{
  const response =await axiosClient.post(Apis.PQRSMeasure_VisitDetails,payload)
  return response.data
}

export const getMipsReportFileName = async (params) => {
  const response = await axiosClient.post(Apis.ExportMIPSReport, params)

  return response.data
}
export const downloadMips = async (params) => {
  const response = await axiosClient.get(
    `${Apis.Production_downloadDetails}?filePath=${encodeURIComponent(params)}`,
    {
      responseType: 'blob',
    },
  )

  return response.data
}